import { baseApi } from 'store/api/base-api';
import { Plan, PlansResponse } from 'types/payment';

export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlans: builder.query<Array<Plan>, void>({
      query: () => ({ url: 'prices', method: 'GET' }),
      transformResponse: (response: PlansResponse): Array<Plan> => {
        const { plans } = response;
        return plans;
      },
    }),
  }),
});

export const { useGetPlansQuery } = paymentApi;
